var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adminUserToken)?_c('div',{staticClass:"md-layout admin-logout-container"},[_c('div',{staticClass:"md-layout-item"},[_vm._v(" admin is using account "),_c('span',{on:{"click":function($event){return _vm.adminLeaveGame()}}},[_c('md-icon',{staticClass:"fa fa-times-circle link"})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }